import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Navigation = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("polygon", { id: "Path", fill: "#008CBA", points: "12 2 4.5 20.29 5.21 21 12 18 18.79 21 19.5 20.29" })));
};
export default Navigation;
